import React, { useEffect, useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    useDataProvider,
    Loading,
    Error,
} from "react-admin";

/* =======================
   TABLE VIEW: /#/sevas
======================= */
export const SevaList = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="pujaName" />
            <TextField source="title" />
            <NumberField source="amount" />
        </Datagrid>
    </List>
);

/* =======================
   FULL EDIT VIEW: /#/seva-admin
======================= */

export const SevaAdmin = () => {
    const dataProvider = useDataProvider();

    const [sevaDoc, setSevaDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        dataProvider
            .getList("sevas", {
                pagination: { page: 1, perPage: 1000 },
                sort: { field: "title", order: "ASC" },
                filter: {},
            })
            .then(({ data }) => {
                const grouped = {};

                data.forEach(item => {
                    if (!grouped[item.title]) {
                        grouped[item.title] = [];
                    }
                    grouped[item.title].push({ [item.pujaName]: item.amount });
                });

                setSevaDoc(grouped);
                setLoading(false);
            })
            .catch(err => {
                setError(err);
                setLoading(false);
            });
    }, [dataProvider]);

    if (loading) return <Loading />;
    if (error) return <Error error={error} />;

    const updatePujaName = (catKey, i, newName) => {
        const doc = { ...sevaDoc };
        const amount = doc[catKey][i][Object.keys(doc[catKey][i])[0]];
        doc[catKey][i] = { [newName]: amount };
        setSevaDoc(doc);
    };

    const updatePujaAmount = (catKey, i, val) => {
        const doc = { ...sevaDoc };
        const name = Object.keys(doc[catKey][i])[0];
        doc[catKey][i] = { [name]: Number(val) };
        setSevaDoc(doc);
    };

    const addPuja = (catKey) => {
        const doc = { ...sevaDoc };
        doc[catKey].push({ "New Puja": 0 });
        setSevaDoc(doc);
    };

    const removePuja = (catKey, i) => {
        const doc = { ...sevaDoc };
        doc[catKey].splice(i, 1);
        setSevaDoc(doc);
    };

    const removeCategory = (catKey) => {
        const doc = { ...sevaDoc };
        delete doc[catKey];
        setSevaDoc(doc);
    };

    // ✅ SAVE TO API
    const saveSevaDoc = async () => {
        try {

            const token = localStorage.getItem("token");
            const response = await fetch(
                process.env.REACT_APP_BASE_URL + "admin/seva/update",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token
                    },
                    body: JSON.stringify(sevaDoc),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to update");
            }

            alert("✅ Seva updated successfully!");
        } catch (err) {
            console.error(err);
            alert("❌ Failed to save Seva");
        }
    };


    return (
        <div style={{ padding: 20 }}>
            <h1>Edit Seva Document</h1>

            {Object.entries(sevaDoc).map(([category, pujas]) => (
                <div key={category} style={{ marginBottom: 40 }}>
                    <h2>
                        {category}
                        <button
                            onClick={() => removeCategory(category)}
                            style={{ color: "red", marginLeft: 10 }}
                        >
                            Delete Category
                        </button>
                    </h2>

                    {pujas.map((p, i) => {
                        const name = Object.keys(p)[0];
                        const amount = p[name];

                        return (
                            <div key={i} style={{ display: "flex", gap: 10, marginBottom: 6 }}>
                                <input
                                    value={name}
                                    onChange={(e) =>
                                        updatePujaName(category, i, e.target.value)
                                    }
                                />
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) =>
                                        updatePujaAmount(category, i, e.target.value)
                                    }
                                    style={{ width: 100 }}
                                />
                                <button
                                    onClick={() => removePuja(category, i)}
                                    style={{ color: "red" }}
                                >
                                    Delete
                                </button>
                            </div>
                        );
                    })}

                    <button onClick={() => addPuja(category)}>Add Puja</button>
                </div>
            ))}

            <button
                onClick={saveSevaDoc}
                style={{ fontSize: 18, padding: "10px 20px", marginTop: 20 }}
            >
                💾 Save All Changes
            </button>
        </div>
    );
};

export default SevaAdmin;
